import React, { useState, useCallback } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "حساب الطاقة الكامنة - احسب الطاقة الكامنة، الكتلة، أو الارتفاع";
const DESCRIPTION =
  "حاسبة الطاقة الكامنة الشامل: قم بحساب الطاقة الكامنة، الكتلة، أو الارتفاع بناءً على القيم المدخلة للكتلة، الارتفاع، أو الطاقة الكامنة. أداة دقيقة وسهلة الاستخدام.";
const KEYWORDS =
  "طاقة كامنة, حساب الطاقة الكامنة, حاسبة الطاقة الكامنة, حساب الكتلة, حساب الارتفاع, فيزياء";
const OG_URL = "https://do-calculate.com/calculator/ar/potentialenergy";
function PotentialEnergyCalculator() {
  const [mass, setMass] = useState("");
  const [height, setHeight] = useState("");
  const [potentialEnergy, setPotentialEnergy] = useState("");
  const [calculationMode, setCalculationMode] = useState(
    "calculatePotentialEnergy"
  );
  const [error, setError] = useState("");
  const [showSteps, setShowSteps] = useState(false);
  const updateCalculations = useCallback(() => {
    setError("");
    const massValue = parseInt(mass, 10) || 0;
    const heightValue = parseInt(height, 10) || 0;
    const potentialEnergyValue = parseInt(potentialEnergy, 10) || 0;
    switch (calculationMode) {
      case "calculatePotentialEnergy":
        if (massValue > 0 && heightValue > 0) {
          const calculatedPotentialEnergy = 9.81 * massValue * heightValue;
          setPotentialEnergy(Math.round(calculatedPotentialEnergy));
        } else {
          setError("الرجاء إدخال الكتلة والارتفاع بشكل صحيح");
        }
        break;
      case "calculateMass":
        if (potentialEnergyValue > 0 && heightValue > 0) {
          const calculatedMass = potentialEnergyValue / (9.81 * heightValue);
          setMass(Math.round(calculatedMass));
        } else {
          setError("الرجاء إدخال الطاقة الكامنة والارتفاع بشكل صحيح");
        }
        break;
      case "calculateHeight":
        if (potentialEnergyValue > 0 && massValue > 0) {
          const calculatedHeight = potentialEnergyValue / (9.81 * massValue);
          setHeight(Math.round(calculatedHeight));
        } else {
          setError("الرجاء إدخال الطاقة الكامنة والكتلة بشكل صحيح");
        }
        break;
      default:
        break;
    }
  }, [mass, height, potentialEnergy, calculationMode]);
  const handleCalculateClick = () => {
    updateCalculations();
    setShowSteps(true);
  };
  const handleMassChange = (e) => setMass(e.target.value);
  const handleHeightChange = (e) => setHeight(e.target.value);
  const handlePotentialEnergyChange = (e) => setPotentialEnergy(e.target.value);
  const handleModeChange = (e) => setCalculationMode(e.target.value);
  const getSolutionSteps = () => {
    switch (calculationMode) {
      case "calculatePotentialEnergy":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الطاقة الكامنة:</h4>
            <ol>
              <li>ادخل الكتلة (بالكيلوجرام) في الحقل المخصص.</li>
              <li>ادخل الارتفاع (بالمتر) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الطاقة الكامنة.</li>
              <li>الطاقة الكامنة تساوي 9.81 × الكتلة × الارتفاع.</li>
            </ol>
          </div>
        );
      case "calculateMass":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الكتلة:</h4>
            <ol>
              <li>ادخل الطاقة الكامنة (بالجول) في الحقل المخصص.</li>
              <li>ادخل الارتفاع (بالمتر) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الكتلة.</li>
              <li>الكتلة تساوي الطاقة الكامنة / (9.81 × الارتفاع).</li>
            </ol>
          </div>
        );
      case "calculateHeight":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الارتفاع:</h4>
            <ol>
              <li>ادخل الطاقة الكامنة (بالجول) في الحقل المخصص.</li>
              <li>ادخل الكتلة (بالكيلوجرام) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الارتفاع.</li>
              <li>الارتفاع يساوي الطاقة الكامنة / (9.81 × الكتلة).</li>
            </ol>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تتيح لك حاسبة الطاقة الكامنة إجراء ثلاث أنواع من الحسابات
                  استنادًا إلى القيم المدخلة. اختر نوع الحساب المناسب لك وأدخل
                  القيم المتوفرة لحساب القيمة المفقودة بدقة وسهولة.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الطاقة الكامنة بمعلومية الكتلة والارتفاع
                </h2>
                <p>
                  إذا كنت تعرف الكتلة (بـ الكيلوجرام) والارتفاع (بـ متر)، يمكنك
                  حساب الطاقة الكامنة (بـ الجول) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الطاقة الكامنة = 9.81 × الكتلة × الارتفاع</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الكتلة بمعلومية الطاقة الكامنة والارتفاع
                </h2>
                <p>
                  إذا كنت تعرف الطاقة الكامنة (بـ الجول) والارتفاع (بـ متر)،
                  يمكنك حساب الكتلة (بـ الكيلوجرام) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الكتلة = الطاقة الكامنة / (9.81 × الارتفاع)</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الارتفاع بمعلومية الكتلة والطاقة الكامنة
                </h2>
                <p>
                  إذا كنت تعرف الكتلة (بـ الكيلوجرام) والطاقة الكامنة (بـ
                  الجول)، يمكنك حساب الارتفاع (بـ متر) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الارتفاع = الطاقة الكامنة / (9.81 × الكتلة)</b>
                </p>
                <p>
                  استخدم هذه الأداة لإدخال القيم المتاحة وحساب القيمة المفقودة
                  بدقة، مما يسهل عليك إجراء الحسابات الفيزيائية المتعلقة بالطاقة
                  الكامنة.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group align-items-center">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="calculationMode"
                      >
                        اختر نوع الحساب
                      </label>
                    </b>
                    <div id="calculationMode">
                      <br />
                      <div>
                        <input
                          type="radio"
                          id="calculatePotentialEnergy"
                          name="calculationMode"
                          value="calculatePotentialEnergy"
                          checked={
                            calculationMode === "calculatePotentialEnergy"
                          }
                          onChange={handleModeChange}
                        />
                        <label
                          htmlFor="calculatePotentialEnergy"
                          className="ms-2"
                        >
                          حساب الطاقة الكامنة
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateMass"
                          name="calculationMode"
                          value="calculateMass"
                          checked={calculationMode === "calculateMass"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateMass" className="ms-2">
                          حساب الكتلة
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateHeight"
                          name="calculationMode"
                          value="calculateHeight"
                          checked={calculationMode === "calculateHeight"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateHeight" className="ms-2">
                          حساب الارتفاع
                        </label>
                      </div>
                    </div>
                  </div>
                  <br />
                  {calculationMode !== "calculateMass" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="massInput">
                          الكتلة (كيلوجرام)
                        </label>
                      </b>
                      <input
                        id="massInput"
                        type="number"
                        placeholder="80"
                        value={mass}
                        onChange={handleMassChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateHeight" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="heightInput"
                        >
                          الارتفاع (متر)
                        </label>
                      </b>
                      <input
                        id="heightInput"
                        type="number"
                        placeholder="10"
                        value={height}
                        onChange={handleHeightChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculatePotentialEnergy" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="potentialEnergyInput"
                        >
                          الطاقة الكامنة (جول)
                        </label>
                      </b>
                      <input
                        id="potentialEnergyInput"
                        type="number"
                        placeholder="320"
                        value={potentialEnergy}
                        onChange={handlePotentialEnergyChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculateClick}
                  >
                    احسب                  </button>
                  <br/>                  <div>
                    { (
                      <>
                        {error !== "" && (
                          <p className="p-3 mb-2 bg-warning text-white">
                            خطأ: {error}
                          </p>
                        )}
                        {calculationMode === "calculatePotentialEnergy" &&
                          potentialEnergy !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              الطاقة الكامنة (جول): {potentialEnergy} جول
                            </p>
                          )}
                        {calculationMode === "calculateMass" && mass !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            الكتلة (كيلوجرام): {mass} كيلوجرام
                          </p>
                        )}
                        {calculationMode === "calculateHeight" &&
                          height !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              الارتفاع (متر): {height} متر
                            </p>
                          )}
                        {showSteps && getSolutionSteps()}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default PotentialEnergyCalculator;
